import AuthStore from './AuthStore';
import ProductStore from './ProductStore';
import cartStore from './CartStore';
import ServiceStore from './ServiceStore';
import AppointmentStore from './AppointmentStore';
import PetStore from './PetStore';
import PartnerDashboardStore from './PartnerDashboardStore';
import PartnerOrderStore from './PartnerOrderStore';
import PartnerInventoryStore from './PartnerInventoryStore';
import PartnerServiceStore from './PartnerServiceStore';
import PartnerAppointmentStore from './PartnerAppointmentStore';
import AdminProductStore from './AdminProductStore';
import AdminPartnerStore from './AdminPartnerStore';
import AdminDashboardStore from './AdminDashboardStore';
import FavoriteStore from './FavoriteStore';
import NotificationStore from './NotificationStore';

class RootStore {
  constructor() {
    this.authStore = new AuthStore(this);
    this.productStore = new ProductStore(this);
    this.cartStore = cartStore;
    this.serviceStore = new ServiceStore(this);
    this.appointmentStore = new AppointmentStore(this);
    this.petStore = new PetStore(this);
    this.partnerDashboardStore = new PartnerDashboardStore(this);
    this.partnerOrderStore = new PartnerOrderStore(this);
    this.partnerInventoryStore = new PartnerInventoryStore(this);
    this.partnerServiceStore = new PartnerServiceStore(this);
    this.partnerAppointmentStore = new PartnerAppointmentStore(this);
    this.adminProductStore = new AdminProductStore(this);
    this.adminPartnerStore = new AdminPartnerStore(this);
    this.adminDashboardStore = new AdminDashboardStore(this);
    this.favoriteStore = new FavoriteStore(this);
    this.notificationStore = new NotificationStore(this);
  }
}

export default RootStore;
